import { Copy, FolderInput, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
	ErrorButton,
	OutlinedPrimaryButton,
	PrimaryButton,
} from "src/components/Default/LekUI/Button";
import { SelectionBar } from "src/components/SelectionBar/SelectionBar";

interface FolderSelectionBarProps {
	selectedCount: number;
	onMoveToFolder: () => void;
	onCopyToFolder: () => void;
	onRemove: () => void;
	onClose: () => void;
}

export const FolderSelectionBar = ({
	selectedCount,
	onMoveToFolder,
	onCopyToFolder,
	onRemove,
	onClose,
}: FolderSelectionBarProps) => {
	const { t } = useTranslation();

	return (
		<SelectionBar
			selectedCount={selectedCount}
			onClose={onClose}
			actions={
				<>
					<PrimaryButton
						data-test-id="folder-selection-move-button"
						onClick={onMoveToFolder}
						disabled={selectedCount === 0}
						className="flex items-center gap-8 folder-selection-bar-btn"
					>
						<FolderInput className="icon-small" />
						<span className="folder-selection-bar-text">
							{t("folder.move", "Przenieś")}
						</span>
					</PrimaryButton>
					<OutlinedPrimaryButton
						data-test-id="folder-selection-copy-button"
						onClick={onCopyToFolder}
						disabled={selectedCount === 0}
						className="flex items-center gap-8 folder-selection-bar-btn"
					>
						<Copy className="icon-small" />
						<span className="folder-selection-bar-text">
							{t("folder.copy", "Kopiuj")}
						</span>
					</OutlinedPrimaryButton>
					<ErrorButton
						data-test-id="folder-selection-remove-button"
						onClick={onRemove}
						disabled={selectedCount === 0}
						className="flex items-center gap-8 folder-selection-bar-btn"
					>
						<Trash2 className="icon-small" />
						<span className="folder-selection-bar-text">
							{t("folder.removeFromFolder", "Usuń")}
						</span>
					</ErrorButton>
				</>
			}
		/>
	);
};
